import { render } from "./cancelledDeliveryChallan.vue?vue&type=template&id=165e6fcf"
import script from "./cancelledDeliveryChallan.vue?vue&type=script&lang=js"
export * from "./cancelledDeliveryChallan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__